import React from 'react';
import {intlShape} from 'react-intl';
import moment from 'moment';
import PropTypes from 'prop-types';

const TimeAgo = (props, {intl}) => {
	const {time} = props;
	const formatted = intl.formatDate(time);
	props = Object.assign({}, props);
	delete props.time;
	return (
		<time {...props} dateTime={time} title={formatted}>
			{IS_BROWSER ? intl.formatRelative(time) : formatted}
		</time>
	);
};

export const SmartDate = ({time}) => {
	const inputTime = moment(time);
	const now = moment();
	const yearAgo = now.subtract(1, 'year');
	let format = "Do MMM";

	if (inputTime.isBefore(yearAgo)) {
		format = "MMM YYYY";
	}

	return (
		<time dateTime={time} title={inputTime.format("HH:mm - Do of MMMM YYYY")}>{moment(time).format(format)}</time>
	)
}

TimeAgo.propTypes = {
	time: PropTypes.oneOfType([
		PropTypes.instanceOf(Date).isRequired,
		PropTypes.string.isRequired,
	]),
};

TimeAgo.contextTypes = {
	intl: intlShape,
};

export default TimeAgo;



// WEBPACK FOOTER //
// ./lib/components/time.js